import React from "react";
import '../components/css/PrivacyPolicy.css';
import HeaderComponent from '../components/HeaderComponent';


const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>

        <ol className="privacy-list">
          <li>
            BookMyAudition is sensitive to privacy issues on the Internet. We believe it is important you know how we treat the information about you we receive via the Internet.

          </li>

          <li>
            In general, you can visit BookMyAudition on the World Wide Web without telling us who you are or revealing any information about yourself. Our web servers collect the domain names, not the e-mail addresses, of visitors. This information may be aggregated on a "no names" basis to measure the number of visits, average time spent on the site, pages viewed, etc. BookMyAudition uses this information to measure the use of our site and to improve the content of our site.
          </li>

          <li>
            There are times, however, when we may need information from you, such as your name and address. When information is needed, we will let you know at the time of collection, how we will use the personal information. Usually, the personal information we collect is used only by us to respond to your inquiry, process an order or allow you to access specific account information.
          </li>

          <li>
            BookMyAudition makes every effort to maintain the security of its network and the data we collect. Any data that is stored on BookMyAudition server is treated as proprietary and confidential and is not available to the public. BookMyAudition has a strict internal security policy with respect to the confidentiality of customer and other data, limiting access only to those employees who have a need to know such information for the purpose of effectively delivering BookMyAudition products and services.
          </li>

          <li>
            BookMyAudition is very sensitive to the issue of children's privacy and makes every effort to protect the privacy of children surfing the web. If you believe your child has provided BookMyAudition with personally-identifiable data, or registered at one of 9Audition web sites, and you would like to have them removed, please contact support@9audition.com.
          </li>

          <li>
            At times we conduct on-line surveys to better understand the needs and profile of our visitors. When we conduct a survey, we will try to let you know how we will use the information at the time we collect information from you on the Internet.
          </li>

          <li>
            BookMyAudition's website may contain links to other Web sites. While we try to link only to sites that share our high standards and respect for privacy, we are not responsible for the content or the privacy practices employed by other sites.
          </li>

          <li>
            For more information or if you have questions or concerns regarding BookMyAudition's Privacy Statement, please send an e-mail to support@bookmyaudition.com.
          </li>
        </ol>

      </div>

    </div>
  );
};

export default PrivacyPolicy;